"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graph_1 = require("../graph");
const base_query_graph_1 = require("./base-query/base-query-graph");
const filter_1 = require("./filter");
const transform_1 = require("./transform");
const column_order_1 = require("./column-order");
class V2QuantumGraph {
    static deserialize(obj) {
        if (obj['version'] === graph_1.GraphVersions.V2) {
            let graph = new V2QuantumGraph();
            graph.baseQueryGraph = base_query_graph_1.default.deserialize(obj.baseQueryGraph);
            graph.pagination = obj.pagination;
            graph.sort = (obj.sort || []).map(filter_1.Sort.deserialize);
            graph.count = obj.count;
            graph.distinct = obj.distinct;
            graph.filters = (obj.filters || []).map(filter_1.Filter.deserialize);
            graph.transforms = (obj.transforms || []).map(transform_1.Transform.deserialize);
            graph.columnOrder = column_order_1.ColumnOrder.deserialize(obj.columnOrder || []);
            return graph;
        }
        return null;
    }
    getVersion() {
        return graph_1.GraphVersions.V2;
    }
    serialize() {
        return {
            version: graph_1.GraphVersions.V2,
            baseQueryGraph: this.baseQueryGraph.serialize(),
            pagination: this.pagination,
            sort: this.sort.map(sort => sort.serialize()),
            count: this.count,
            distinct: this.distinct,
            filters: this.filters.map(filter => filter.serialize()),
            transforms: this.transforms.map(transform => transform.serialize()),
            columnOrder: this.columnOrder.serialize(),
        };
    }
    // eslint-disable-next-line no-unused-vars
    forEachTable(f) {
        this.baseQueryGraph.forEach(f);
    }
    validate(datasetRepo) {
        let valid = this.baseQueryGraph.validate(datasetRepo);
        // Validate that each node has an id and it's unique
        let seenIds = new Set();
        this.forEachTable(node => {
            if (!node.id)
                valid = false;
            else if (seenIds.has(node.id))
                valid = false;
            seenIds.add(node.id);
        });
        // Validate sort references columns
        for (let sort of this.sort) {
            valid = valid && sort.validate(this.lookup.bind(this));
        }
        // Validate all filters
        for (let filter of this.filters) {
            valid = valid && filter.validate(this.lookup.bind(this));
        }
        // Validate column order
        valid = valid && this.columnOrder.validate(this.lookup.bind(this));
        return valid;
    }
    lookup(id) {
        return this.baseQueryGraph.lookup(id);
    }
}
exports.default = V2QuantumGraph;
